import "../css/style.scss";

import { initMenu } from "./modules/menu";
import { activateSlider } from "./modules/slider";
import { initAccordion } from "./modules/accordion";
import { initCounter } from "./modules/counter";
import { initModal } from "./modules/modal";
import { initSearch } from "./modules/search";
import { initCategories } from "./modules/categories";
import { initLoadMore } from "./modules/load-more";

document.addEventListener("DOMContentLoaded", () => {
  initMenu();

  const searchForm = document.querySelector(".search-form");
  if (searchForm) {
    initSearch();
  }

  const containerSelectors = document.querySelectorAll(
    ".testimonial-container"
  );
  containerSelectors.forEach((container) => {
    activateSlider(container);
  });

  const modalElements = document.querySelectorAll(".openModalBtn");
  if (modalElements.length > 0) {
    initModal();
  }

  const counterElements = document.querySelectorAll(".image-counter");
  if (counterElements.length > 0) {
    initCounter();
  }

  const accordionElements = document.querySelectorAll(".accordion");
  if (accordionElements.length > 0) {
    initAccordion();
  }

  const formWrapper = document.querySelectorAll(".gform_wrapper");
  if (formWrapper.length > 0) {
    var requiredFields = document.querySelectorAll(
      ".gform_wrapper .gfield_required"
    );
    requiredFields.forEach(function (field) {
      field.innerHTML = "*";
    });
  }

  const categoryList = document.querySelectorAll(".aktuelles__categories");
  if (categoryList.length > 0) {
    initCategories();
  }

  const loadMore = document.querySelector(".aktuelles-load-more");
  if (loadMore) {
    initLoadMore();
  }

  const teamImages = document.querySelectorAll(".team__image");
  if (teamImages.length > 0) {
    for (let i = 1; i < teamImages.length - 1; i += 4) {
      teamImages[i].classList.add('team__image--red-icon');
      teamImages[i + 1].classList.add('team__image--red-icon');
    }
  }

  const galleryElements = document.querySelectorAll(".wp-block-gallery");
  galleryElements.forEach((gallery) => {
    const imageWrappers = gallery.querySelectorAll(".wp-block-image a");
    const captions = gallery.querySelectorAll(".wp-element-caption");

    const imageOverlay = document.createElement("div");
    imageOverlay.className = "wp-block-image-overlay";

    imageWrappers.forEach((imageWrapper) => {
      imageWrapper.appendChild(imageOverlay.cloneNode());
    });

    captions.forEach((caption) => {
      caption.style.display = "none";
    });
  });
});
